import CalendarView from "./components/CalendarView"

let module = "calendar"

export default [
  {
    path: "calendar",
    component: CalendarView,
    props: true,
    meta: { module: module, permissions: ["calendar-access"] }
  }
]
